import { createMuiTheme } from '@material-ui/core/styles';
import { NONAME } from 'dns';

import {
  COLOR_ACCORDION_PALE,
  COLOR_ACTION_BLUE,
  COLOR_ACTION_BLUE_10,
  COLOR_ACTION_BLUE_20,
  COLOR_ACTION_BLUE_30,
  COLOR_ACTION_BLUE_40,
  COLOR_ACTION_BLUE_70,
  COLOR_ACTION_BLUE_90,
  COLOR_DARK_GREY,
  COLOR_DARKEST_BLUE,
  COLOR_ERROR_RED,
  COLOR_KASVU_THEME,
  COLOR_LINE_GREY,
  COLOR_SUCCESS_GREEN,
  COLOR_SUPER_PALE,
  COLOR_TEXT_BLUE,
  COLOR_WARNING_ORANGE,
  COLOR_WHITE,
  SHADOW_FLOAT_ELEVATED_LARGE,
  SHADOW_FLOAT_ELEVATED_MEDIUM,
  SHADOW_FLOAT_ELEVATED_SMALL,
  TYPOGRAPHY_BODY_LARGE_LINE_HEIGHT,
  TYPOGRAPHY_BODY_LARGE_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_BODY_LARGE_SIZE,
  TYPOGRAPHY_BODY_LARGE_SIZE_MOBILE,
  TYPOGRAPHY_BODY_LARGE_WEIGHT,
  TYPOGRAPHY_BODY_LINE_HEIGHT,
  TYPOGRAPHY_BODY_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_BODY_SIZE,
  TYPOGRAPHY_BODY_SIZE_MOBILE,
  TYPOGRAPHY_BODY_SMALL_LINE_HEIGHT,
  TYPOGRAPHY_BODY_SMALL_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_BODY_SMALL_SIZE,
  TYPOGRAPHY_BODY_SMALL_SIZE_MOBILE,
  TYPOGRAPHY_BODY_SMALL_WEIGHT,
  TYPOGRAPHY_BODY_WEIGHT,
  TYPOGRAPHY_BUTTON_LINE_HEIGHT,
  TYPOGRAPHY_BUTTON_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_BUTTON_SIZE,
  TYPOGRAPHY_BUTTON_SIZE_MOBILE,
  TYPOGRAPHY_BUTTON_WEIGHT,
  TYPOGRAPHY_H1_LINE_HEIGHT,
  TYPOGRAPHY_H1_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_H1_SIZE,
  TYPOGRAPHY_H1_SIZE_MOBILE,
  TYPOGRAPHY_H1_WEIGHT,
  TYPOGRAPHY_H2_LINE_HEIGHT,
  TYPOGRAPHY_H2_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_H2_SIZE,
  TYPOGRAPHY_H2_SIZE_MOBILE,
  TYPOGRAPHY_H2_WEIGHT,
  TYPOGRAPHY_H3_LINE_HEIGHT,
  TYPOGRAPHY_H3_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_H3_SIZE,
  TYPOGRAPHY_H3_SIZE_MOBILE,
  TYPOGRAPHY_H3_WEIGHT,
  TYPOGRAPHY_H4_LINE_HEIGHT,
  TYPOGRAPHY_H4_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_H4_SIZE,
  TYPOGRAPHY_H4_SIZE_MOBILE,
  TYPOGRAPHY_H4_WEIGHT,
  TYPOGRAPHY_H5_LINE_HEIGHT,
  TYPOGRAPHY_H5_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_H5_SIZE,
  TYPOGRAPHY_H5_SIZE_MOBILE,
  TYPOGRAPHY_H5_WEIGHT,
  TYPOGRAPHY_H6_LINE_HEIGHT,
  TYPOGRAPHY_H6_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_H6_SIZE,
  TYPOGRAPHY_H6_SIZE_MOBILE,
  TYPOGRAPHY_H6_WEIGHT,
  TYPOGRAPHY_HERO_LINE_HEIGHT,
  TYPOGRAPHY_HERO_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_HERO_SIZE,
  TYPOGRAPHY_HERO_SIZE_MOBILE,
  TYPOGRAPHY_HERO_WEIGHT,
  TYPOGRAPHY_LINK_LINE_HEIGHT,
  TYPOGRAPHY_LINK_LINE_HEIGHT_MOBILE,
  TYPOGRAPHY_LINK_SIZE,
  TYPOGRAPHY_LINK_SIZE_MOBILE,
  TYPOGRAPHY_LINK_WEIGHT,
  COLOR_GREY_BLUE,
  COLOR_KASVU_BLUE,
  COLOR_KASVU_THEME_LIGHT,
  COLOR_PALE,
  COLOR_CENTER_BORDER,
} from './tokens';

const sliderThumbImage = `
<svg width='13' height='17' viewBox='0 0 13 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <line x1='1.25' y1='1.25' x2='1.25' y2='15.75' stroke='#4680e6' stroke-width='2.5' stroke-linecap='round'/>
    <line x1='11.25' y1='1.25' x2='11.25' y2='15.75' stroke='#4680e6' stroke-width='2.5' stroke-linecap='round'/>
</svg>
`
  .replace(/[\r\n]/gm, '')
  .replace(/#/gm, '%23');

const spacing = [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160];

const theme = {
  typography: {
    fontSize: 14,
    fontFamily: [
      '"Inter"',
      'sans-serif',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: { fontWeight: TYPOGRAPHY_H1_WEIGHT, fontSize: TYPOGRAPHY_H1_SIZE, lineHeight: TYPOGRAPHY_H1_LINE_HEIGHT, textAlign: 'left' },
    h2: { fontWeight: TYPOGRAPHY_H2_WEIGHT, fontSize: TYPOGRAPHY_H2_SIZE, lineHeight: TYPOGRAPHY_H2_LINE_HEIGHT, textAlign: 'left' },
    h3: { fontWeight: TYPOGRAPHY_H3_WEIGHT, fontSize: TYPOGRAPHY_H3_SIZE, lineHeight: TYPOGRAPHY_H3_LINE_HEIGHT, textAlign: 'left' },
    h4: { fontWeight: TYPOGRAPHY_H4_WEIGHT, fontSize: TYPOGRAPHY_H4_SIZE, lineHeight: TYPOGRAPHY_H4_LINE_HEIGHT, textAlign: 'left' },
    h5: { fontWeight: TYPOGRAPHY_H5_WEIGHT, fontSize: TYPOGRAPHY_H5_SIZE, lineHeight: TYPOGRAPHY_H5_LINE_HEIGHT, textAlign: 'left' },
    h6: { fontWeight: TYPOGRAPHY_H6_WEIGHT, fontSize: TYPOGRAPHY_H6_SIZE, lineHeight: TYPOGRAPHY_H6_LINE_HEIGHT, textAlign: 'left' },
    body1: {
      fontWeight: TYPOGRAPHY_BODY_WEIGHT,
      fontSize: TYPOGRAPHY_BODY_SIZE,
      lineHeight: TYPOGRAPHY_BODY_LINE_HEIGHT,
      letterSpacing: '-0.8px',
    },
    body2: {
      fontWeight: TYPOGRAPHY_BODY_SMALL_WEIGHT,
      fontSize: TYPOGRAPHY_BODY_SIZE,
      lineHeight: TYPOGRAPHY_BODY_LINE_HEIGHT,
    },
    subtitle1: {
      fontWeight: TYPOGRAPHY_BODY_LARGE_WEIGHT,
      fontSize: TYPOGRAPHY_BODY_LARGE_SIZE,
      lineHeight: TYPOGRAPHY_BODY_LARGE_LINE_HEIGHT,
      letterSpacing: '-0.1px',
    },
    subtitle2: {
      fontWeight: TYPOGRAPHY_BODY_SMALL_WEIGHT,
      fontSize: TYPOGRAPHY_BODY_SMALL_SIZE,
      lineHeight: TYPOGRAPHY_BODY_SMALL_LINE_HEIGHT,
      letterSpacing: '0.01em',
    },
    link: {
      fontWeight: TYPOGRAPHY_LINK_WEIGHT,
      fontSize: TYPOGRAPHY_LINK_SIZE,
      lineHeight: TYPOGRAPHY_LINK_LINE_HEIGHT,
      letterSpacing: '0.01em',
    },
    button: {
      fontWeight: TYPOGRAPHY_BUTTON_WEIGHT,
      fontSize: TYPOGRAPHY_BUTTON_SIZE,
      lineHeight: TYPOGRAPHY_BUTTON_LINE_HEIGHT,
      letterSpacing: '0.01em',
      textDecoration: 'none',
    },
  },
  palette: {
    common: {
      white: COLOR_WHITE,
    },
    primary: {
      main: COLOR_ACTION_BLUE,
      contrastText: COLOR_WHITE,
    },
    secondary: {
      main: COLOR_WHITE,
      contrastText: COLOR_ACTION_BLUE,
    },
    error: {
      main: COLOR_ERROR_RED,
      contrastText: COLOR_WHITE,
    },
    warning: {
      main: COLOR_WARNING_ORANGE,
      contrastText: COLOR_WHITE,
    },
    success: {
      main: COLOR_SUCCESS_GREEN,
      contrastText: COLOR_WHITE,
    },
    text: {
      primary: COLOR_TEXT_BLUE,
      secondary: COLOR_DARKEST_BLUE,
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      hover: 'rgba(0, 0, 0, 0.04)',
      hoverOpacity: 0.04,
      selected: 'rgba(0, 0, 0, 0.08)',
      selectedOpacity: 0.08,
      focus: 'rgba(0, 0, 0, 0.12)',
      focusOpacity: 0.12,
      activatedOpacity: 0.12,
    },
    grey: {
      '300': COLOR_SUPER_PALE,
      '500': COLOR_LINE_GREY,
      '700': COLOR_DARK_GREY,
    },
    background: {
      default: COLOR_WHITE,
      primary: COLOR_KASVU_THEME_LIGHT,
      secondary: COLOR_PALE,
    },
    info: {
      main: COLOR_KASVU_BLUE,
      contrastText: COLOR_WHITE,
    },
    footer: {
      background: COLOR_KASVU_BLUE,
      color: COLOR_WHITE,
      colorHeader: COLOR_GREY_BLUE,
    },
  },
  shape: {
    borderRadius: 0,
  },
  spacing,

  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          scrollBehavior: 'smooth',
        },
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: COLOR_ACTION_BLUE_90,
      },
    },
    MuiInputBase: {
      root: {
        background: COLOR_WHITE,
      },
      input: {
        fontSize: `${TYPOGRAPHY_BODY_SMALL_SIZE}px`,
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: COLOR_CENTER_BORDER,
      },
    },
    MuiAppBar: {
      root: {},
      colorPrimary: {
        backgroundColor: COLOR_KASVU_THEME_LIGHT,
        color: COLOR_TEXT_BLUE,
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: COLOR_PALE,
      },
    },
    MuiTypography: {
      root: {
        wordBreak: 'break-word',
        hyphens: 'auto',
      },
      gutterBottom: {
        marginBottom: spacing[2],
      },
    },
    MuiDivider: {
      root: {
        borderColor: COLOR_LINE_GREY,
      },
    },
    MuiTabs: {
      root: {},
      indicator: {
        display: 'none',
      },
    },
    MuiTab: {
      root: {
        marginRight: spacing[3],
        padding: spacing[2],
        textTransform: 'none',
        borderLeftWidth: '6px',
        borderLeftStyle: 'solid',
        borderLeftColor: COLOR_ACTION_BLUE,
        fontWeight: TYPOGRAPHY_LINK_WEIGHT,
        fontSize: TYPOGRAPHY_LINK_SIZE,
        lineHeight: TYPOGRAPHY_LINK_LINE_HEIGHT,
        lineBreak: 'normal',
        whiteSpace: 'nowrap',
        maxWidth: 'none',
        color: COLOR_TEXT_BLUE,
        backgroundColor: COLOR_WHITE,

        '&$selected': {
          backgroundColor: COLOR_ACTION_BLUE_20,
          color: `${COLOR_TEXT_BLUE} !important`,
        },

        '&:hover': {
          backgroundColor: COLOR_ACTION_BLUE_10,
        },

        '&:active': {
          backgroundColor: COLOR_ACTION_BLUE_30,
        },

        '&:last-child': {
          margin: 0,
        },
      },
    },
    MuiSlider: {
      root: {
        marginBottom: spacing[2],
        marginTop: spacing[1],
      },
      thumb: {
        height: 30,
        width: 30,
        marginTop: - (spacing[2] / 2),
        marginLeft: -15, // width / 2
        backgroundColor: COLOR_ACTION_BLUE,
        '&:focus, &:hover, &$active': {
          boxShadow: `0px 0px 0px 8px rgba(45, 75, 122, 0.16)`,
        },
        '&::after': {
          content: '""',
          backgroundImage: 'url("data:image/svg+xml;utf8,' + sliderThumbImage + '")',
          backgroundSize: '30%',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          display: 'block',
          position: 'absolute',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
        },
      },
      track: {
        backgroundColor: COLOR_KASVU_THEME,
        height: spacing[2],
        zIndex: 0,
      },
      rail: {
        backgroundColor: '#e7e7e7',
        zIndex: 0,
        height: spacing[2],
      },
    },
    MuiAccordion: {
      root: {
        '&$expanded': {
          marginTop: spacing[3],
          marginBottom: spacing[3],
        },
      },
    },
    MuiAccordionSummary: {
      root: {
        padding: spacing[3],
      },
      content: {
        margin: '0px',
        '&$expanded': {
          margin: '0px',
        },
      },
      expandIconWrapper: {
        transform: 'none !important',
      },
    },
    MuiAccordionDetails: {
      root: {
        padding: spacing[4],
        backgroundColor: COLOR_ACCORDION_PALE,
      },
    },
    MuiButton: {
      root: {
        lineHeight: 1,
        textTransform: 'none',
        boxShadow: 'none',
        minWidth: '120px',
        '&:focus': {
          textDecoration: 'none',
          outline: 'none',
        },
      },
      sizeLarge: {
        paddingTop: '18.5px',
        paddingBottom: '17.5px',
        paddingRight: '20px',
        paddingLeft: '20px',
      },
      sizeSmall: {
        fontSize: '14px',
        lineHeight: '24px',
        letterSpacing: '0.01em',
        padding: '4px 10px',
      },
      endIcon: {
        marginLeft: spacing[4],
      },
      containedPrimary: {        
        '&:hover': {
          color: COLOR_WHITE,
          backgroundColor: COLOR_ACTION_BLUE_90,
        },
        '&:active, &:focus': {
          color: COLOR_WHITE,
          backgroundColor: COLOR_ACTION_BLUE_70,
        },
      },
      containedSecondary: {
        '&:hover': {
          backgroundColor: COLOR_ACTION_BLUE_10,
        },
        '&:active, &:focus': {
          backgroundColor: COLOR_ACTION_BLUE_20,
        },
      },
    },
  },
};

function applyThemeMods(theme) {
  theme.shadows[1] = SHADOW_FLOAT_ELEVATED_SMALL;
  theme.shadows[2] = SHADOW_FLOAT_ELEVATED_MEDIUM;
  theme.shadows[3] = SHADOW_FLOAT_ELEVATED_LARGE;

  theme.typography.h1[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_H1_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_H1_LINE_HEIGHT_MOBILE,
  };
  theme.typography.h2[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_H2_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_H2_LINE_HEIGHT_MOBILE,
  };
  theme.typography.h3[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_H3_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_H3_LINE_HEIGHT_MOBILE,
  };
  theme.typography.h4[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_H4_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_H4_LINE_HEIGHT_MOBILE,
  };
  theme.typography.h5[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_H5_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_H5_LINE_HEIGHT_MOBILE,
  };
  theme.typography.h6[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_H6_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_H6_LINE_HEIGHT_MOBILE,
  };
  theme.typography.body1[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_BODY_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_BODY_LINE_HEIGHT_MOBILE,
  };
  theme.typography.body2[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_BODY_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_BODY_LINE_HEIGHT_MOBILE,
  };
  theme.typography.subtitle1[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_BODY_LARGE_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_BODY_LARGE_LINE_HEIGHT_MOBILE,
  };
  theme.typography.subtitle2[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_BODY_SMALL_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_BODY_SMALL_LINE_HEIGHT_MOBILE,
  };
  theme.typography.link[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_LINK_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_LINK_LINE_HEIGHT_MOBILE,
  };
  theme.typography.button[theme.breakpoints.down('md')] = {
    fontSize: TYPOGRAPHY_BUTTON_SIZE_MOBILE,
    lineHeight: TYPOGRAPHY_BUTTON_LINE_HEIGHT_MOBILE,
  };

  return theme;
}

export default applyThemeMods(createMuiTheme(theme));